import { DropTarget } from 'react-dnd';
import React from 'react';
import { DragItemTypes } from 'constants/DragConstants';
import DimensionsConstants from 'constants/DimensionsConstants';
import MarginDropLine from './MarginDropLine';

const codeTarget = {
  drop(props, monitor) {
    const item = monitor.getItem();
    const didDrop = monitor.didDrop();

    if (!didDrop) {
      const position = props.dropPosition || 1;
      if (props.nestCodes) {
        props.nestCodes(item.codeID, null, position);
        props.endDrag();
      }
    }
  }
};

function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true }),
    draggedItem: monitor.getItem(),
  };
}

const BottomMarginDropZone = ({ 
  connectDropTarget, 
  isOver,
  draggedItem,
}) => {
  const shouldShow = !!draggedItem && isOver;

  return connectDropTarget(
    <div style={{
      minHeight: DimensionsConstants.BOTTOM_DROP_ZONE_HEIGHT || '20px',
      position: 'relative',
      paddingTop: '0px'
    }}>
      <MarginDropLine
        show={shouldShow}
        canDrop={true} // Always allow drops at bottom
        depth={0} // Always at root level
      />
    </div>
  );
};

export default DropTarget(DragItemTypes.CODE_LABEL, codeTarget, collectTarget)(BottomMarginDropZone);